import {FaCalendar, FaList} from 'react-icons/fa';
import {TabPanel, TabView} from 'primereact/tabview';
import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import DelegationListContainer from './DelegationListContainer';
import DelegationCalendarContainer from './DelegationCalendarContainer';

class DelegationTabContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: localStorage.getItem("delegation-tab-index") ? parseInt(localStorage.getItem("delegation-tab-index")) : 0 
        };
        if (props.handleRenderHeader) {
            props.handleRenderHeader(() => null);
        }
    }

    onTabChange = (e) =>{
        this.setState({
            activeIndex: e.index
        }, ()=> this.saveIndexCookie())
    }

    saveIndexCookie(){
        localStorage.setItem("delegation-tab-index", this.state.activeIndex);
    }

    render() {
        return (
            <div className='delegation-tab'>
                <TabView style={{marginLeft: '16px'}} onTabChange={(e)=>{this.onTabChange(e)}} activeIndex={this.state.activeIndex}>
                    <TabPanel
                        className='tab-list'
                        header={
                            <div>
                                <FaList /> Lista
                            </div>
                        }
                    >
                        <DelegationListContainer detailUrl='/#/my-delegation/details' newUrl='/#/my-delegation/create' />
                    </TabPanel>
                    <TabPanel
                        className='tab-calendar'
                        header={
                            <div>
                                <FaCalendar /> Kalendarz
                            </div>
                        }
                    >
                            <DelegationCalendarContainer />

                    </TabPanel>
                </TabView>
            </div>
        );
    }
}
export default withTranslation()(DelegationTabContainer);
